import { render, staticRenderFns } from "./math-question.vue?vue&type=template&id=7f872abe&scoped=true&"
import script from "../../assets/js/exam/math-question.js?vue&type=script&lang=js&"
export * from "../../assets/js/exam/math-question.js?vue&type=script&lang=js&"
import style0 from "../../assets/css/exam.css?vue&type=style&index=0&id=7f872abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f872abe",
  null
  
)

export default component.exports